module.exports = __webpack_public_path__ + "static/media/mohren-hell-k.3edf04fc.png";